import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,  
  Label,
  Dropdown,
  Radio,
  Message
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { settingsActions } from '../../actions/settings.actions';

class SettingsEditScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settings: {    
        userLockDomain: '',
        userLockServer: '',
        databaseProvider: '',
        integratedSecurity: false,
        dbHost: '',
        dbName: '',
        dbUser: '',
        dbPass: '',
      },
      errors: {},
      submitted: false
    };    
  }

  componentDidMount() {
    const { dispatch } = this.props;    
    dispatch(settingsActions.fetch())
            .then(() => {                
                const settings = this.props.settings;
                this.setState({ settings })
            });
  }

  static get propTypes() { 
    return {       
        settings: PropTypes.any,
        loading: PropTypes.bool
    }; 
  }

  handleChange(field, data) {        
    const { settings } = this.state;    
    settings[field] = data;    
    this.setState({ settings });    
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { settings } = this.state;    

    dispatch(settingsActions.update(settings));
  }

  render() {    
    const { settings, errors } = this.state;     
    const databaseProviders = [
      { key: "SqlServer", value: "SqlServer", text: "SQL Server" },      
    ];

    if (settings.forbidden) {
      return (<Message negative>
        <Message.Header>Acesso Negado</Message.Header>
        <p>Configurações só podem ser acessadas através do servidor</p>
      </Message>);
    }

    return (  
      <Fragment>
      <h1>Configurações</h1>
      <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
        <Form.Input required error={errors.userLockServer} label='Servidor UserLock' value={settings.userLockServer} name='userLockServer' type='text' onChange={(e, data) => this.handleChange("userLockServer", data.value)} placeholder='. para servidor local' />
        { errors.userLockServer && <Label color='red'>{errors.userLockServer}</Label>}

        <Form.Input error={errors.userLockDomain} label='Domínio UserLock' value={settings.userLockDomain} name='userLockServer' type='text' onChange={(e, data) => this.handleChange("userLockDomain", data.value)} placeholder='' />
        { errors.userLockServer && <Label color='red'>{errors.userLockServer}</Label>}

        <h3>Banco de Dados</h3>
        <Form.Field required>
            <label>Tipo</label>
            <Dropdown
              placeholder='Selecione'
              fluid            
              selection
              onChange={(e, data) => this.handleChange("databaseProvider", data.value)}
              options={databaseProviders}
              value={settings.databaseProvider} 
            />
            { errors.databaseProvider && <Label basic pointing  color='red'>{errors.databaseProvider}</Label>}
          </Form.Field>       

        <Form.Input required error={errors.dbHost} label='Host' value={settings.dbHost} name='dbHost' type='text' onChange={(e, data) => this.handleChange("dbHost", data.value)} placeholder='Hostname ou IP' />
        { errors.dbHost && <Label color='red'>{errors.dbHost}</Label>}

        <Form.Input required error={errors.dbSchema} label='Database' value={settings.dbName} name='dbSchema' type='text' onChange={(e, data) => this.handleChange("dbName", data.value)} placeholder='' />
        { errors.dbSchema && <Label color='red'>{errors.dbSchema}</Label>}

        <Form.Input>
          <Radio toggle checked={settings.integratedSecurity} label='Usar autenticação integrada' onChange={(e, data) => this.handleChange("integratedSecurity", data.checked)} />
        </Form.Input>
        
        <Form.Input disabled={settings.integratedSecurity} error={errors.dbUser} label='Usuário' value={settings.dbUser} name='dbUser' type='text' onChange={(e, data) => this.handleChange("dbUser", data.value)} />
        { errors.dbUser && <Label color='red'>{errors.dbUser}</Label>}

        <Form.Input disabled={settings.integratedSecurity} error={errors.dbPass} label='Senha' value={settings.dbPass} name='dbPass' type='password' onChange={(e, data) => this.handleChange("dbPass", data.value)} placeholder='Deixe em branco para manter' />
        { errors.dbPass && <Label color='red'>{errors.dbPass}</Label>}
                
        <Button primary type='submit'>Salvar</Button>
      </Form>
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { settings } = state;    
  return { settings, loading: settings.loading || false };  
}

const connectedconnectedSettingsEditScreen = connect(mapStateToProps)(SettingsEditScreen);
export { connectedconnectedSettingsEditScreen as SettingsEditScreen };
